import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from "react-router-dom";
import Dashboard_svg from "../assets/image/sidebarIcons/Dashboard.svg";
import Accounts_svg from "../assets/image/sidebarIcons/Accounts.svg";
import Education_svg from "../assets/image/sidebarIcons/Education.svg";
import { NavigationRoutes } from '../../constant/Routes';
// import Others_svg from "../assets/image/sidebarIcons/Others.svg";

const SidebarLinks = ({ Toggle }) => {
    const [active_dropdown, setActiveDropdown] = useState('');
    const [active_tab, setActiveTab] = useState('');
    const [active_menu, setActiveMenu] = useState({ dashboard: false, education: false, account: false, other: false, misc: false });

    const currentLocation = useLocation().pathname;
    const base = '/admin_dashboard'



    const DLink1 = (currentLocation, name, url, icon, id, parentId) => {




        useEffect(() => {

            if (currentLocation === (url ? base + '/' + url : base)) {
                // console.log(changeTab1())
            }

        }, [currentLocation, id, parentId, url])


        return (
            <NavLink

                to={url}
                id={id}
                className={`sidebar_options_link ${active_dropdown === id ? "sidebar_options_active" : ""}`}
                onClick={() => {
                    if (Toggle) {

                        document.getElementById('dashboard-collapse').classList.remove('show');
                        document.getElementById('user-list-collapse').classList.remove('show');
                        document.getElementById('vehicle-listing-collapse').classList.remove('show');
                        setActiveMenu((pre) => {

                            return {
                                dashboard: false,
                                account: false,
                                education: false
                            }
                        })
                    }
                    setActiveDropdown(id);
                    setActiveTab(parentId)
                }}
            >
                <img src={icon} className=" Sidebar_text sidebar_icons" alt="" />
                <span className="text-dark " style={{ fontSize: "0.9rem" }}>{name}</span>
            </NavLink>
        );
    };

    return (
        <div>
            {/* ---- first dropdown---- */}
            <div className="flex-shrink-0">
                <ul className="list-unstyled m-0">
                    <a
                        onClick={() => {


                            document.getElementById('user-list-collapse').classList.remove('show');
                            // document.getElementById('vehicle-listing-collapse').classList.remove('show');
                            setActiveMenu((pre) => {

                                return {
                                    dashboard: true,
                                    // account: false,
                                    // education: false
                                }
                            })

                            setActiveMenu((pre) => {

                                return {
                                    ...pre,
                                    dashboard: !active_menu.dashboard
                                }
                            })

                        }}
                        href="#!"
                        style={Toggle ?
                            !active_menu.dashboard ?
                                { width: '60px', borderBottomRightRadius: `${active_menu.dashboard === true ? '0px' : ''}` }
                                :
                                { borderBottomRightRadius: `${active_menu.dashboard === true ? '0px' : ''}` }
                            : { borderBottomRightRadius: `${active_menu.dashboard === true ? '0px' : ''}` }}
                        className={`data-toggle sidebar_options_drop d-flex justify-content-between ${active_tab === 'dashboard-collapse-btn' ? 'active_tab' : ''} ${active_menu.dashboard === true ? 'active_tab' : ''} `}
                        role="button"
                        id="dashboard-collapse-btn"
                        data-bs-toggle="collapse" data-bs-target="#dashboard-collapse" aria-expanded="true"
                    >
                        <div>
                            <img
                                src={Dashboard_svg}
                                className="Sidebar_text  sidebar_icons"
                                alt=""
                            />
                            <span className="text-dark " style={

                                Toggle ?
                                    !active_menu.dashboard ? { display: 'none', fontSize: "0.9rem" } :
                                        { fontSize: "0.9rem" } : { fontSize: "0.9rem" }}>Dashboard</span>
                        </div>
                        {!Toggle && <i className={`fas fa-chevron-down mr-3 ${active_menu.dashboard ? "toggle-up" : "toggle-down"}`}></i>}
                    </a>


                    <div className="collapse collapse_superadmin p-0" id="dashboard-collapse">
                        <ul className={`${Toggle ? 'btn-toggle-nav-hide' : 'btn-toggle-nav'}  list-unstyled `}>
                            <li className="dropdown_items_div ml-1">

                                {DLink1(currentLocation, "Dashboard", "", "ok", 'Dashboard', 'dashboard-collapse-btn')}
                                {/* 
                                {DLink1(currentLocation, "Dashboard 1", "admintable", "ok", 'My_Admin', 'dashboard-collapse-btn')}
                                {DLink1(currentLocation, "Dashboard 2", "activitytable", "ok", 'My_Activity', 'dashboard-collapse-btn')} */}

                            </li>
                        </ul>
                    </div>
                </ul>
            </div>


            {/* ---- secound dropdown---- */}
            <div className="flex-shrink-0">
                <ul className="list-unstyled m-0">
                    <a
                        onClick={() => {
                            document.getElementById('dashboard-collapse').classList.remove('show');
                            // document.getElementById('vehicle-listing-collapse').classList.remove('show');
                            setActiveMenu((pre) => {

                                return {
                                    // dashboard: false,
                                    // account: false,
                                    education: true
                                }
                            })
                            setActiveMenu((pre) => { return { ...pre, education: !active_menu.education } })
                        }}
                        href="#!"
                        // style={{ borderBottomRightRadius: `${active_menu.education === true ? '0px' : ''}` }}
                        style={Toggle ?
                            !active_menu.education ?
                                { width: '60px', borderBottomRightRadius: `${active_menu.education === true ? '0px' : ''}` }
                                :
                                { borderBottomRightRadius: `${active_menu.education === true ? '0px' : ''}` }
                            : { borderBottomRightRadius: `${active_menu.education === true ? '0px' : ''}` }}
                        className={`data-toggle sidebar_options_drop d-flex justify-content-between ${active_tab === 'user-list-collapse-btn' ? 'active_tab' : ''} ${active_menu.education === true ? 'active_tab' : ''} `}
                        role="button"
                        // data-toggle="collapse"
                        id="user-list-collapse-btn"
                        data-bs-toggle="collapse" data-bs-target="#user-list-collapse" aria-expanded="true"
                    >
                        <div>
                            <img
                                src={Education_svg}
                                className="  Sidebar_text  sidebar_icons"
                                alt=""
                            />
                            <span style={
                                Toggle ?
                                    !active_menu.education ? { display: 'none', fontSize: "0.9rem", } :
                                        { fontSize: "0.9rem" } : { fontSize: "0.9rem" }} className="text-dark ">User listing</span>
                        </div>
                        {!Toggle && <i className={`fas fa-chevron-down mr-3 ${active_menu.education ? "toggle-up" : "toggle-down"}`}></i>}
                    </a>

                    <div className="collapse collapse_superadmin" id="user-list-collapse">
                        <ul className={`${Toggle ? 'btn-toggle-nav-hide' : 'btn-toggle-nav'}  list-unstyled `}>
                            <li className="dropdown_items_div ml-1">
                                {DLink1(currentLocation, "Verified User", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.VERIFIED_USER_LISTING}`, "ok", "user-lisitng-1", 'user-list-collapse-btn')}

                            </li>
                        </ul>
                    </div>


                    <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Categories Management", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.CATEGORIES}`, Education_svg, "categories-lisitng-1", 'categories-list-collapse-btn')}


                    </li>


                    <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Plan Management", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.PLANS}`, Education_svg, "plans-lisitng-1", 'plans-list-collapse-btn')}


                    </li>


                    <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Vehicles Management", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.VEHICLE}`, Education_svg, "vehicles-lisitng-1", 'vehicles-list-collapse-btn')}


                    </li>


                    <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Vehicle Make/Model", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.VEHICLE_MAKE}`, Education_svg, "vehicle-make-1", 'adminSe-list-collapse-btn')}

                    </li>
                </ul>
            </div>






            {/* ---- Settings Dropdown ---- */}
            <div className="flex-shrink-0">
                <ul className="list-unstyled m-0">
                    <li>
                        <a
                            onClick={() => {
                                document.getElementById('dashboard-collapse')?.classList.remove('show');
                                setActiveMenu((pre) => ({
                                    ...pre,
                                    settings: !active_menu.settings
                                }));
                                setActiveTab('settings-collapse-btn');
                            }}
                            href="#!"
                            style={
                                Toggle
                                    ? !active_menu.settings
                                        ? { width: '60px', borderBottomRightRadius: '0px' }
                                        : {}
                                    : {}
                            }
                            className={`data-toggle sidebar_options_drop d-flex justify-content-between ${active_tab === 'settings-collapse-btn' ? 'active_tab' : ''} ${active_menu.settings ? 'active_tab' : ''}`}
                            role="button"
                            id="settings-collapse-btn"
                            data-bs-toggle="collapse"
                            data-bs-target="#settings-collapse"
                            aria-expanded="true"
                        >
                            <div>
                                <img src={Education_svg} className="Sidebar_text sidebar_icons" alt="" />
                                <span className="text-dark" style={Toggle && !active_menu.settings ? { display: 'none', fontSize: "0.9rem" } : { fontSize: "0.9rem" }}>
                                    Settings
                                </span>
                            </div>
                            {!Toggle && <i className={`fas fa-chevron-down mr-3 ${active_menu.settings ? "toggle-up" : "toggle-down"}`}></i>}
                        </a>
                    </li>

                    <div className="collapse collapse_superadmin p-0" id="settings-collapse">
                        <ul className={`${Toggle ? 'btn-toggle-nav-hide' : 'btn-toggle-nav'} list-unstyled`}>
                            <li className="dropdown_items_div ml-1">
                                {DLink1(currentLocation, "Content Settings", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.HEADERSETTINGS}`, Education_svg, "content-settings-1", 'settings-collapse-btn')}
                            </li>
                            <li className="dropdown_items_div ml-1">
                                {DLink1(currentLocation, "FAQ Settings", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.FAQS}`, Education_svg, "faqs-settings-1", 'settings-collapse-btn')}
                            </li>
                        </ul>
                    </div>
                </ul>
            </div>



            {/* ---- Blog Dropdown ---- */}
            <div className="flex-shrink-0">
                <ul className="list-unstyled m-0">
                    <a
                        onClick={() => {
                            document.getElementById('dashboard-collapse')?.classList.remove('show');
                            setActiveMenu((pre) => ({
                                ...pre,
                                blog: !active_menu.blog
                            }));
                            setActiveTab('blog-collapse-btn');
                        }}
                        href="#!"
                        style={Toggle ? !active_menu.blog ? { width: '60px', borderBottomRightRadius: '0px' } : {} : {}}
                        className={`data-toggle sidebar_options_drop d-flex justify-content-between ${active_tab === 'blog-collapse-btn' ? 'active_tab' : ''} ${active_menu.blog ? 'active_tab' : ''}`}
                        role="button"
                        id="blog-collapse-btn"
                        data-bs-toggle="collapse" data-bs-target="#blog-collapse" aria-expanded="true"
                    >
                        <div>
                            <img src={Education_svg} className="Sidebar_text sidebar_icons" alt="" />
                            <span className="text-dark" style={Toggle && !active_menu.blog ? { display: 'none', fontSize: "0.9rem" } : { fontSize: "0.9rem" }}>Blog Management</span>
                        </div>
                        {!Toggle && <i className={`fas fa-chevron-down mr-3 ${active_menu.blog ? "toggle-up" : "toggle-down"}`}></i>}
                    </a>

                    <div className="collapse collapse_superadmin p-0" id="blog-collapse">
                        <ul className={`${Toggle ? 'btn-toggle-nav-hide' : 'btn-toggle-nav'} list-unstyled`}>
                            <li className="dropdown_items_div ml-1">
                                {DLink1(currentLocation, "Add Blog", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.ADD_BLOG}`, Education_svg, 'Add_Blog', 'blog-collapse-btn')}
                                {DLink1(currentLocation, "Blog Listing", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.BLOG}`, Education_svg, 'Blog_Listing', 'blog-collapse-btn')}
                            </li>
                        </ul>
                    </div>
                </ul>
            </div>


            <div className="flex-shrink-0">
                <ul className="list-unstyled m-0">

                    <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Contact Us", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.CONTACTUS}`, Education_svg, "contact-us-lisitng-1", 'contact-us-list-collapse-btn')}


                    </li>





                </ul></div>




            <div className="flex-shrink-0">
                <ul className="list-unstyled m-0">

                    <li className="dropdown_items_div ml-1">

                        {DLink1(currentLocation, "Ad Reports", `${NavigationRoutes.ADMIN_DASHBOARD}${NavigationRoutes.ADREPORTS}`, Education_svg, "ad-report-lisitng-1", 'ad-report-list-collapse-btn')}


                    </li>





                </ul></div>







        </div>
    );
};

export default SidebarLinks;